import "%modules%/header/header";
import "%modules%/team/team";
import "%modules%/topical/topical";
import "%modules%/achievements/achievements";
import "%modules%/main-slider/main-slider";
import "%modules%/slider-block/slider-block";
import "%modules%/video/video";
import "%modules%/scroll/scroll";
import "%modules%/fancybox/fancybox";
import "%modules%/event/event";
// import "%modules%/collapsing-sections/collapsing-sections";
// import "%modules%/insurance/insurance";
// import "%modules%/brands/brands";
// import "%modules%/contact/contact";
// import "%modules%/news-slider/news-slider";
// import "%modules%/card-inner/card-inner";
// import "%modules%/models/models";
